import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import type { GeoJsonFeature } from "@typings/components/map";
import type { CollarGeoJsonProperties } from "@services/device/collar/getGeoJson/type";

interface CollarPopupProps {
  feature: GeoJsonFeature<CollarGeoJsonProperties>;
  onNavigate: (path: string) => void;
}

function CollarPopup({ feature, onNavigate }: CollarPopupProps) {
  if (!feature || !feature.properties) {
    return (
      <div className="p-3">
        <Text size="sm" className="text-red-500">
          Erro ao carregar dados
        </Text>
      </div>
    );
  }

  const device = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/devices/collar/${device.id}`);
  };

  return (
    <div className="flex flex-col gap-3 px-2 py-1 min-w-[220px]">
      <div className="flex items-center justify-between">
        <Heading size="sm">Rastreador</Heading>
      </div>

      <div className="space-y-2">
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Número: </span> {device.number}
        </Text>
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas: </span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>

        {device.responsibleTeam && (
          <Text size="sm" className="font-roboto">
            <span className="font-semibold">Equipe Responsável: </span>{" "}
            {device.responsibleTeam}
          </Text>
        )}
        {device.individual && (
          <Text size="sm" className="font-roboto">
            <span className="font-semibold">Indivíduo: </span>{" "}
            {device.individual}
          </Text>
        )}
      </div>

      <Button
        size="auto"
        customVariant="secondary"
        className="mt-2"
        onClick={handleNavigate}
      >
        Mais Detalhes
      </Button>
    </div>
  );
}

export default CollarPopup;
